<!-- components/YelloopCheckForm.vue -->
<template>
  <h3 class="fw-bold fs-6 p-2 text-lg-start">
    {{ translate('SA20YelloopCheckTitle') }}
  </h3>

  <!-- Field 1: Rejoin Intention -->
  <div :class="classes.row_intention">
    <label :class="classes.label">
      {{ translate('SA20YelloopCheckRejoinIntentionLabel') }}
    </label>
    <div :class="classes.status">
      <Status />
    </div>
    <div :class="classes.input">
      <select
        v-model="rejoinIntentionModel"
        class="form-select form-control"
        :class="{
          'is-invalid': v$.rejoin_intention?.$error,
        }"
        name="rejoin_intention"
      >
        <option value="">{{ translate('placeholderSelect') }}</option>
        <option v-for="(label, value) in YELLOOP_CHECK_REJOIN_INTENTION_VALUES" :key="value" :value="Number(value)">
          {{ label }}
        </option>
      </select>
      <InputErrorMessage :title="translate('SA20YelloopCheckRejoinIntentionLabel')" :validator="v$.rejoin_intention?.$errors[0]?.$validator" />
    </div>
  </div>

  <!-- Field 2: Desired Information -->
  <div :class="classes.row_information">
    <label :class="classes.label">
      {{ translate('SA20YelloopCheckDesiredInformationLabel') }}
    </label>
    <div :class="classes.status">
      <Status />
    </div>
    <div :class="classes.input">
      <select
        v-model="desiredInformationModel"
        class="form-select form-control"
        :class="{
          'is-invalid': v$.desired_information?.$error,
        }"
        name="desired_information"
      >
        <option value="">{{ translate('placeholderSelect') }}</option>
        <option v-for="(label, value) in YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES" :key="value" :value="Number(value)">
          {{ label }}
        </option>
      </select>
      <InputErrorMessage :title="translate('SA20YelloopCheckDesiredInformationLabel')" :validator="v$.desired_information?.$errors[0]?.$validator" />
    </div>
  </div>
</template>
<script setup>
import { translate } from '@/languages/i18n'
import Status from '@/components/status/index.vue'
import InputErrorMessage from '@/components/input-error-message/InputErrorMessage.vue'
import { computed } from 'vue'
import { YELLOOP_CHECK_REJOIN_INTENTION_VALUES, YELLOOP_CHECK_REJOIN_DESIRED_INFORMATION_VALUES } from '@/constants/index'

const props = defineProps({
  isEditProfile: {
    type: Boolean,
    default: false,
  },
  v$: {
    type: Object,
    required: true,
  },
  rejoinIntention: {
    type: [String, Number],
    default: '',
  },
  desiredInformation: {
    type: [String, Number],
    default: '',
  },
})

const emit = defineEmits(['update:rejoinIntention', 'update:desiredInformation'])

const rejoinIntentionModel = computed({
  get: () => props.rejoinIntention ?? '',
  set: (val) => emit('update:rejoinIntention', val),
})

const desiredInformationModel = computed({
  get: () => props.desiredInformation ?? '',
  set: (val) => emit('update:desiredInformation', val),
})

const classes = computed(() => {
  if (props.isEditProfile) {
    return {
      label: 'w-max-content col-lg-2 col-form-label text-black fs-7',
      status: 'w-max-content col-lg-2 col-form-label',
      input: 'col-lg-8 px-0 mx-lg-0 mb-3 mb-lg-0',
      row_intention: 'border-bottom row mx-0 px-0 pb-4 gx-3 my-4',
      row_information: 'row mx-0 px-0 pb-4 gx-3',
    }
  }
  return {
    label: 'w-max-content col-lg-2 col-form-label text-black',
    status: 'w-max-content col-lg-1 col-form-label',
    input: 'col-lg-5 mx-lg-0 mb-3 mb-lg-0',
    row_intention: 'border-bottom row mx-0 px-0 pb-4 gx-3 my-4',
    row_information: 'border-bottom row mx-0 px-0 pb-4 gx-3 mb-4',
  }
})
</script>

<style lang="scss" scoped>
h3 {
  background: $base-gray-100;
}
</style>
